import React from "react";
import { useHistory } from "react-router";

const urlType = {
  favorites: "/favorite",
  listing: "/listing",
};

export default function SecondHeaderBS() {
  const history = useHistory();
  const goToHomeBusiness = () => {
    history.push("/bs/home");
  };
  const goToFavoritesBusiness = () => {
    history.push("/bs/favorites");
  };
  const goToMylistingsBusiness = () => {
    history.push("/bs/listings");
  };
  const goToPostAd = () => {
    history.push("/bs/post");
  };
  const url = window.location.href;

  const renderActive = (type: string) => {
    return url?.includes(type) ? "active" : "";
  };
  return (
    <div className="secondMenu">
      <div className="container mx-auto">
        <div className="leftItemHeader">
          <h2 className="title">
            <a
              className="colorInherit"
              href="javascript:;"
              onClick={(e) => {
                e.preventDefault();
                goToHomeBusiness();
              }}
            >
              Business Services
            </a>
          </h2>
          <div className="menuDynamic bl">
            <div className="item">
              <a
                href="javascript:;"
                onClick={(e) => {
                  e.preventDefault();
                  goToFavoritesBusiness();
                }}
                className={renderActive(urlType?.favorites)}
              >
                Favorites
              </a>
            </div>
            <div className="item">
              <a
                href="javascript:;"
                onClick={(e) => {
                  e.preventDefault();
                  goToMylistingsBusiness();
                }}
                className={renderActive(urlType?.listing)}
              >
                My listings
              </a>
            </div>
            <div className="item">
              <div className="searchWord classified">
                <input type="text" className="keyword" value="" />
                <button>
                  <span className="icon-search"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="rightItemHeader">
          <div className="item">
            <a
              href="javascript:;"
              className="startPost"
              onClick={(e) => {
                e.preventDefault();
                goToPostAd();
              }}
            >
              Post an ad
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
